module.exports = __webpack_public_path__ + "img/download.103b96fb.svg";